import React, { useState, useEffect, useRef } from "react";
import "../../App.css";


import FeatureSection from "../shared/FeatureSection";
import QuickLinksSection from "./QuickLinksSection";
import {BackToProductsButton} from "../layout/BackButton";

// Updated Maps & Data Products page with back button
function MapsDataProductsPage({ handleNavClick }) {
  return (
    <div className="product-detail-page">
      {/* Back Arrow Button */}
      <BackToProductsButton handleNavClick={handleNavClick} />

      {/* Planet Satellite Header with Background */}
      <div className="planet-header">
        <div className="section__container">
          <h2 className="section__title">Planet Satellite</h2>
          <p className="section__intro">
            Planet Labs, commonly known as Planet, is a leading Earth observation company operating the world's largest fleet of imaging satellites.
          </p>
        </div>
      </div>
      {/* Detailed Content */}
      <div className="esri_content_bg">
        <FeatureSection
          title="Why Planet?"
          text=" Planet was founded with the mission to image the Earth every day and make change visible, accessible, and actionable. Over the past decade with our customers, Planet has revolutionized the Earth observation industry, democratizing access to satellite data beyond the traditional agriculture and defense sectors."
          imgSrc="/planet.jpg"
          imgAlt="Spatial Analytics"
        />

        <section className="esri-about-section">
          <div className="section__container esri-about-container">
            <div className="esri-about-text">
              <h2>Planet Monitoring</h2>
              <p>
                Planet Monitoring provides near-daily, 3.7-meter resolution imagery covering all of Earth’s landmass. Access to these ready-to-use images is made simple with Planet’s APIs, web application, and GIS integrations. Available through a subscription model, Planet Monitoring can be scaled to the requirements of your analysis and application needs.
              </p>
              <br></br>
            </div>
            <div className="esri-about-image">
              <img src="products/Planet/Planet Monitoring.png" alt="ESRI Logo" />
            </div>
          </div>
        </section>
        <FeatureSection
          title="Planet Tasking "
          text="At 50 cm resolution, Planet Tasking provides organizations with near-real-time intelligence to proactively identify blind spots, anticipate events, and have confidence in the next mission-critical decision."
          imgSrc="products/Planet/Planet Tasking 1.png"
          imgAlt="Spatial Analytics"
        />

        <FeatureSection
          title="Monitor Offering"
          text="Planet Monitoring delivers up-to-date insights and satellite images from the areas that matter to you, on a daily basis. With Planet’s growing visual archive, analyze deep stacks of imagery from 2009 until today. Leverage Planet’s global coverage to observe areas of strategic importance at a local, national, and international level. Survey broad areas at scale to identify changes and make timely interventions."
          imgSrc="/planet3.jpg"
          imgAlt="Field Operations"
          reverse
        />

        <FeatureSection
          title="Reliable Data from Around the World"
          text="With Planet fleet of high resolution tasking satellites, Planet offers the most frequent, intraday revisit capability of any commercial provider, capturing actionable insights sub-daily for real-time decision making."
          imgSrc="/planet4.png"
          imgAlt="Mapping"
        />
      </div>
      <QuickLinksSection
        handleNavClick={handleNavClick}
        links={[
          { id: 'software-products', title: 'ESRI Software', icon: '/esri-logo.jpg', bgClass: 'esri-quick-bg' },
          { id: 'hardware-products', title: 'Idea Forge', icon: '/ideaforge1.jpg', bgClass: 'idea-quick-bg' },
          { id: 'heremaps', title: 'Here Maps', icon: '/here.jpg', bgClass: 'here-quick-bg' }
        ]}
      />
    </div>
  );
}

export default MapsDataProductsPage;